<template>
  <div class="tw-relative">
    <div ref="trigger">
      <slot :count="totalUnread" :open="open"></slot>
    </div>
    <div v-show="is_open" ref="menu" class=" tw-rounded tw-overflow-hidden tw-bg-light tw-shadow tw-w-120 ">
      <div class="tw-divide-y tw-divide-light-3">
        <div class="tw-text-2xl tw-font-bold tw-p-4">Latest Updated Chats:</div>
        <div v-if="loading" class="tw-p-10 tw-flex flex-center">
          <i class="bx bx-loader-alt bx-spin tw-text-4xl"></i>
        </div>
        <template v-else>
          <div v-if="latestChats.length === 0" class="tw-py-16 tw-text-center tw-font-bold tw-text-light-11">No New Messages</div>
          <a
            target="_blank" v-on:click="delayedRefresh"
            :href="`/dashboard/message?chat=${chat.id}`" class="tw-p-4 tw-flex tw-items-center tw-space-x-4 cursor:tw-bg-light-2 cursor:tw-text-blue"
            v-for="chat in latestChats" :key="chat.id"
          >
            <img :src="chat.image" class="tw-w-16 tw-h-16 tw-rounded-full tw-object-cover" alt="">
            <div>
              <div class="tw-font-semibold">{{chat.title}}</div>
              <div class="tw-text-dark-3 tw-text-opacity-75">{{chat.updated_at}}</div>
            </div>
          </a>
          <a href="/dashboard/message" class="tw-block tw-p-4 tw-text-center cursor:tw-bg-light-2 cursor:tw-text-blue tw-font-bold">Show All</a>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
  import {createPopper} from "@popperjs/core";

  export default {
    data: v => ({
      is_open: false,
      chats: [],
      totalUnread: v.initialTotalUnread,
      loading: false,
      last_update: 0,
      last_broadcast: 0,
      initialized: false,
    }),
    props: {
      user: {},
      initialTotalUnread: {},
    },
    created() {
      this.open = _.throttle(() => {
        this.needsRefresh && this.refresh()
        this.is_open = true
      }, 100)
      this.close = _.throttle(() => this.is_open = false, 100)

      Echo.private('user.' + this.user.id)
        .listen('ChatUpdated', e => {
          this.refresh()
        })
        .listen('ChatRead', e => {
          console.log('read!')
          this.refresh()
        })
        .listen('ChatCreated', e => {
          this.refresh()
        })

      let documentClickCallback = ev => {
        if (ev.target !== this.$el && !this.$el.contains(ev.target)) {
          this.close()
        }
      }
      this.$on('hook:mounted', () => document.addEventListener('click', documentClickCallback))
      this.$on('hook:beforeDestroy', () => document.removeEventListener('click', documentClickCallback))
    },
    computed: {
      latestChats() {
        return _.chain(this.chats)
          .slice(0, 4)
          .value()
      },
      needsRefresh() {
        return this.initialized === false || this.last_update < this.last_broadcast
      },
    },
    methods: {
      delayedRefresh() {
        setTimeout(() => this.refresh(), 500)
      },
      refresh() {
        this.loading = true
        axios.get(`/api/v2/chat/latest`, {
          params: {api_token: this.user.api_token},
        }).then(resp => {
          console.log(resp.data)
          this.chats = resp.data.data
          this.totalUnread = resp.data.total
        }).finally(() => {
          this.loading = false
          this.initialized = true
          this.last_update = Date.now()
        })
      }
    },
    watch: {
      is_open(value) {
        value && createPopper(this.$refs.trigger, this.$refs.menu, {
          placement: "bottom"
        })
      }
    }
  }
</script>
